import { ExtendedModel } from '../components/Models';

/**
 * Static configuration for custom models
 * Add or modify models directly in this file
 */
export const customModels: ExtendedModel[] = [
];

/**
 * Get a custom model by ID
 */
export const getCustomModelById = (id: string): ExtendedModel | undefined => {
    return customModels.find(model => model.id === id);
};

/**
 * Get models for a specific provider
 */
export const getModelsByProvider = (providerId: string): ExtendedModel[] => {
    return customModels.filter(model => model.providerId === providerId);
}; 